import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  InputAdornment,
  Tooltip,
  Checkbox,
  IconButton,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  Paper,
} from "@mui/material";
import { FontFamily } from "assets";
import { PrimaryButton } from "components/Buttons";
import { v4 as uuidv4 } from "uuid";
import styled from "@emotion/styled";
import { CleanTypes, getFileSize } from "utils";
import { CommaSeparator } from "utils";
import instance from "config/axios";
import routes from "services/System/routes";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { FiDownload, FiFile,  } from "react-icons/fi";
import { Add } from "@mui/icons-material";
import JSZip from "jszip";
import SelectField from "components/Select";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import { useForm } from "react-hook-form";
import { SearchIcon } from "assets";
import Colors from "assets/Style/Colors";
import { Delete } from "@mui/icons-material";
import UploadFile from "components/UploadFile";
import SupplierServices from "services/Supplier";
import FinanceServices from "services/Finance";
import { useSelector } from "react-redux";

const roundToDecimals = (value, decimals) => {
  const numericValue = Number(value || 0);
  if (!Number.isFinite(numericValue)) return 0;
  return Number(numericValue.toFixed(decimals));
};

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
     fontWeight: 700,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "left",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".css-1ru1j9e-MuiTableCell-root ": {
      color: "#ffffff",
      textAlign: "left",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

function EditBill() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    resetField,
    setValue,
    getValues,
  } = useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { usdExchangeRate } = useSelector((state) => state.navigationReducer);

  const [billDate, setBillDate] = useState(new Date());
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [vehicleDetails, setVehicleDetails] = useState();

  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedBillCategory, setSelectedBillCategory] = useState("");
  const [selectedVatCodeType, setSelectedVatCodeType] = useState("");
  const [selectedBillType, setSelectedBillType] = useState("");
  const [documentList, setDocumentList] = useState([]);
  const [documentLink2, setDocumentLink2] = useState("");
  const [isDocumentSelected, setIsDocumentSelected] = useState(false);
  const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);
  const [progress2, setProgress2] = useState(0);
  const [uploadedSize2, setUploadedSize2] = useState(0);
  const [documentDetail2, setDocumentDetail2] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);

  const [isSearching, setIsSearching] = useState(false);
  const [filters, setFilters] = useState({});
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchData, setSearchData] = useState([]);
  const [billDetails, setBillDetails] = useState();

  const [loadings, setLoadings] = useState(false);
  const [rowOpen, setRowOpen] = useState({});
  const [path, setPath] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [addedItemIds, setAddedItemIds] = useState([]);
  const [exchangeRateAed, setExchangeRateAed] = useState();
  const [exchangeRateUsd, setExchangeRateUsd] = useState();

  const [addedRows, setAddedRows] = useState([]);
  console.log(addedRows, "addedRows");
  const [documentFile2, setDocumentFile2] = useState(null);
   const [globalVatLocked, setGlobalVatLocked] = useState(false);
   const allowFilesTypeInvoice = ["application/pdf", "image/jpg", "image/jpeg", ];

  const handleBillDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setBillDate("invalid");
        return;
      }
      setBillDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadDocumentInvoices = async (e) => {
    try {
      e.preventDefault();

      setIsDocumentSelected(true);
      setIsDocumentUploaded(false);

      const file = e.target.files[0];
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ]; 
      if (allowFilesTypeInvoice.includes(file.type)) {
        setDocumentDetail2(arr);
        setDocumentFile2(file);
        handleUploadInvoices(file, arr);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getAllDataOfAccounts = async (page, limit, filter) => {
    setLoadings(true);
    const Page = page ? page : currentPage;
    const Limit = limit ? limit : pageLimit;
    const Filter = { ...filters, ...filter };
    setCurrentPage(Page);
    setPageLimit(Limit);
    setFilters(Filter);

    try {
      let params = {
        page: Page,
        limit: Limit,
        excludeL2: true,
      };
      params = { ...params, ...Filter };

      const { data } = await FinanceServices.getAllAccountsData(params);
      setSearchData(data?.accounts);
    } catch (error) {
      setLoadings(false);
      ErrorToaster(error);
    }
  };

  const handleFilter = async (data) => {
    const q = (data?.search ?? "").trim();
    if (!q) {
      setSearchData([]);
      setLoadings(false);
      return;
    }

    setLoadings(true);
    if (isSearching) return;

    setIsSearching(true);
    try {
      await getAllDataOfAccounts(1, "", { search: q });
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoadings(false);
    }
  };

  const handleUploadInvoices = async (file, docs) => {
    setProgress2(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress2(percentCompleted);
          setUploadedSize2(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail2(docs);
        setDocumentLink2(data?.data?.nations);
        SuccessToaster("Document Uploaded");
        setIsDocumentUploaded(true);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleAddDocument = () => {
    if (!documentLink2) {
      ErrorToaster("Please upload a document before adding.");
      return;
    }

    if (!selectedDocumentType?.id)
      return ErrorToaster("Please enter document Type");
const isImage =
      documentFile2 &&
      ["image/jpg", "image/jpeg"].includes(documentFile2.type);
    setDocumentList([
      ...documentList,
      {
        id: uuidv4(),
        docType: selectedDocumentType?.name,
        doc_id: selectedDocumentType?.id,
        documentLink2,
        fileName: documentFile2?.name || "",
        fileType: documentFile2?.type || "",
        isImage,
        previewUrl: isImage ? URL.createObjectURL(documentFile2) : null,
      },
    ]);
    SuccessToaster("Document Added");
    setSelectedDocumentType([]);
    setDocumentLink2("");
      setDocumentDetail2([]);
    setDocumentFile2(null);
  };

  const images =
    vehicleDetails?.pictures?.map((picture, index) => {
      if (picture.startsWith("https://static.w8shipping.com/image")) {
        return picture;
      } else {
        return process.env.REACT_APP_IMAGE_BASE_URL + picture;
      }
    }) || [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const total = images.length;

  const currentImage = images[currentIndex];

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const totalSelectedCount = useMemo(
    () => Object.keys(selectedItems).length,
    [selectedItems],
  );

  const removeAddedRow = (row_key) => {
    setAddedRows((prev) => prev.filter((row) => row.row_key !== row_key));
  };

  const VAT_GLOBAL_5 = new Set([
    "GUC SRP5%",
    "GWS SRP5%",
    "ICLGG SRP5%",
    "ICLGC SRP5%",
    "RAK SRP5%",
  ]);
  const VAT_LOCKED = new Set(["ZR 0%", "ES", "OOS"]);

  const getVatName = (vat) => (typeof vat === "string" ? vat : vat?.name || "");

  const calcRow = (row) => {
    const vatName = getVatName(row.vat_code);
    const vat_amount = vatName.includes("5%") ? 5 : 0;
    const amountNum = Number(row.amount || 0);
    const total = (amountNum + vat_amount).toFixed(2);
    const bill_amount_lcy = roundToDecimals(amountNum, 2);
    const vat_amount_lcy = roundToDecimals(vat_amount, 2);

    return {
      ...row,
      vat_amount,
      total,
      bill_amount_lcy,
      vat_amount_lcy,
    };
  };

  const isGlobal5Applied = React.useMemo(() => {
    return addedRows.some((r) => VAT_GLOBAL_5.has(getVatName(r.vat_code)));
  }, [addedRows]);

  const updateAddedRow = (row_key, patch) => {
    setAddedRows((prev) =>
      prev.map((row) => {
        if (row.row_key !== row_key) return row;
        const updatedRow = { ...row, ...patch };
        return calcRow(updatedRow);
      }),
    );
  };

  const toggleCheckbox = (id) => {
    setSelectedItems((prev) => {
      const newSelectedItems = { ...prev };
      if (newSelectedItems[id]) {
        delete newSelectedItems[id];
      } else {
        newSelectedItems[id] = true;
      }
      return newSelectedItems;
    });
  };

  const handleAttachmentDownload = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const downloadAllImages = () => {
    const zip = new JSZip();

    const downloadPromises = vehicleDetails?.pictures?.map((imagePath) =>
      fetch(`${process.env.REACT_APP_IMAGE_BASE_URL}${imagePath}`)
        .then((response) => response.blob())
        .then((data) => {
          const filename = imagePath.split("/").pop();
          zip.file(filename, data);
        }),
    );

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: "blob" }).then((blob) => {
        const zipFilename = "images.zip";
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = zipFilename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  };

  const handleBackClick = () => {
    navigate("/vehicle-booking-list");
  };

  const stripHtml = (input = "") => {
    if (!input) return "";
    let out = input.replace(/<[^>]*>/g, "");
    out = out.replace(/on\w+="[^"]*"/gi, "");
    out = out.replace(/\r?\n+/g, " ").trim();
    return out;
  };

  const sqlBadPatterns = [
    /--/i,
    /;/,
    /\/\*|\*\//,
    /\bunion\s+select\b/i,
    /\bdrop\s+(table|database)\b/i,
    /\btruncate\s+table\b/i,
    /\binsert\s+into\b/i,
    /\bupdate\s+.*\s+set\b/i,
    /\bdelete\s+from\b/i,
    /\bxp_[_a-z]+\b/i,
    /\bsys\.[_a-z]+\b/i,
    /\bor\s+1\s*=\s*1\b/i,
  ];

  const MAX_DESC_LEN = 500;

  const sanitizeDescription = (input) => {
    const noHtml = stripHtml(input ?? "");
    const clipped = noHtml.slice(0, MAX_DESC_LEN);
    return clipped;
  };

  const hasSqlInjectionPattern = (input = "") =>
    sqlBadPatterns.some((re) => re.test(input));

  const validateSafeDescription = (value) => {
    const raw = value ?? "";
    const cleaned = sanitizeDescription(raw);
    if (!cleaned) return "Please enter a description.";
    if (hasSqlInjectionPattern(cleaned)) {
      return "Your description contains disallowed patterns.";
    }
    return true;
  };

  useEffect(() => {
    if (totalSelectedCount === 0) {
      setSearchData([]);
      resetField("search");
    }
  }, [selectedItems]);

  useEffect(() => {
    if (searchData) {
      const paths = searchData.map((item) => {
        return [
          item?.cat?.name,
          item?.sub_cat?.name,
          item?.primary?.name,
          item?.name,
        ]
          .filter(Boolean)
          .join(" → ");
      });

      setPath(paths);
    }
  }, [searchData]);
  
  const handleAddFromSearch = (item) => {
    const id = item.id;
   const exRate = item?.currency === "aed" ? exchangeRateAed : exchangeRateUsd;
    if (!selectedItems[id]) {
      return ErrorToaster("Please select the checkbox first.");
    }
  
    const fullPath = [
      item?.cat?.name,
      item?.sub_cat?.name,
      item?.primary?.name,
      item?.name,
    ]
      .filter(Boolean)
      .join(" → ");
     const exRatee = item?.currency === "aed" ? 1 : 3.675;
    setAddedRows((prev) => {
      const count = prev.filter((r) => r.id === id).length;
  
      if (count >= 5) {
        ErrorToaster("You can add this item only 5 times.");
        return prev;
      }
  
   
      const existingGlobalVatCode = prev.find((r) =>
        VAT_GLOBAL_5.has(getVatName(r.vat_code))
      )?.vat_code || "";
  
    
      const row = {
        row_key: Date.now() + Math.random(),
        id,
        parent_id: item?.primary_account_id,
        full_path: fullPath,
        account_code: item?.id || "",
        account_id: item?.id,
        description: "",
        amount: 0,
        bill_amount_lcy: 0,
        vat_amount_lcy: 0,
        vat_amount: 0,
        vat_code: existingGlobalVatCode,
        total: 0,
      };
  
      
      return [...prev, row];
    });
  
    setSelectedItems((prev) => {
      const newSelectedItems = { ...prev };
      delete newSelectedItems[id];
      return newSelectedItems;
    });
  
    setAddedItemIds((prev) => [...prev, id]);
    SuccessToaster("Added.");
  
    if (totalSelectedCount === 0 || Object.keys(selectedItems).length === 0) {
      setSearchData([]);
      resetField("search");
    }
  };
  // const handleAddFromSearch = (item) => {
  //   const id = item.id;

  //   const exRate = item?.currency === "aed" ? exchangeRateAed : exchangeRateUsd;

  //   if (!selectedItems[id]) {
  //     return ErrorToaster("Please select the checkbox first.");
  //   }

  //   const fullPath = [
  //     item?.cat?.name,
  //     item?.sub_cat?.name,
  //     item?.primary?.name,
  //     item?.name,
  //   ]
  //     .filter(Boolean)
  //     .join(" → ");

  //   const exRatee = item?.currency === "aed" ? 1 : 3.675;

  //   const row = {
  //     row_key: Date.now() + Math.random(),
  //     id,
  //     account_id: id,
  //     parent_id: item?.primary_account_id,
  //     full_path: fullPath,
  //     account_code: item?.account_code || "",
  //     description: "",
  //     amount: 0,
  //     vat_amount: 0,
  //     vat_code: selectedVatCodeType?.name || "",
  //     total: 0,
  //     bill_amount_lcy: 0,
  //     vat_amount_lcy: 0,
  //   };

  //   setAddedRows((prev) => {
  //     const count = prev.filter((r) => r.id === id).length;

  //     if (count >= 5) {
  //       ErrorToaster("You can add this item only 5 times.");
  //       return prev;
  //     }

  //     return [...prev, row];
  //   });

  //   setSelectedItems((prev) => {
  //     const newSelectedItems = { ...prev };
  //     delete newSelectedItems[id];
  //     return newSelectedItems;
  //   });

  //   setAddedItemIds((prev) => [...prev, id]);

  //   SuccessToaster("Added.");

  //   if (totalSelectedCount === 0 || Object.keys(selectedItems).length === 0) {
  //     setSearchData([]);
  //     resetField("search");
  //   }
  // };

  const getSupplierData = async () => {
    setLoader(true);

    try {
      let params = {
        page: 1,
        limit: 500,
      };
      const data = await SupplierServices.getSupplier(params);

      const suppliers = data?.data?.suppliers?.rows.map((supplier) => ({
        id: supplier.id,
        name: supplier.company_name,
      }));
      setSuppliers(suppliers);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const vatCode5Percent = React.useMemo(() => {
    const row = addedRows.find((r) => {
      const vatName =
        typeof r.vat_code === "string" ? r.vat_code : r.vat_code?.name;

      return vatName?.includes("5%");
    });

    return typeof row?.vat_code === "string"
      ? row.vat_code
      : row?.vat_code?.name || null;
  }, [addedRows]);

  const effectiveUsdExchangeRate = Number(usdExchangeRate) || 3.675;

  const vatAmountUsdTotal = React.useMemo(() => {
    let sum = 0;

    for (const r of addedRows || []) {
      const v = Number(r?.vat_amount ?? 0);
      if (!isNaN(v)) sum += v / effectiveUsdExchangeRate;
    }

    return Number(sum.toFixed(2));
  }, [addedRows, effectiveUsdExchangeRate]);

  const vatAmountAedTotal = React.useMemo(() => {
    let sum = 0;

    for (const r of addedRows || []) {
      const v = Number(r?.vat_amount ?? 0);
      if (!isNaN(v)) sum += v;
    }

    return Number(sum.toFixed(2));
  }, [addedRows]);

  const totals = React.useMemo(() => {
    let totalAED = 0;
    let totalUSD = 0;

    for (const r of addedRows || []) {
      const amount = Number(r?.total ?? 0);
      if (!amount || isNaN(amount)) continue;
      totalAED += amount;
      totalUSD += amount / effectiveUsdExchangeRate;
    }

    return {
      aed: Number(totalAED.toFixed(2)),
      usd: Number(totalUSD.toFixed(2)),
    };
  }, [addedRows, effectiveUsdExchangeRate]);

  const handleEditBookBill = async () => {
    setLoading(true);

    try {
      if (!selectedSupplier?.id) {
        ErrorToaster("Please select a supplier.");
        setLoading(false);
        return;
      }

      if (!getValues("refNo")) {
        ErrorToaster("Please enter reference number.");
        setLoading(false);
        return;
      }

      if (!getValues("billNo")) {
        ErrorToaster("Please enter bill number.");
        setLoading(false);
        return;
      }

      if (!selectedBillCategory?.name) {
        ErrorToaster("Please select bill category.");
        setLoading(false);
        return;
      }

      if (!selectedBillType?.name) {
        ErrorToaster("Please select bill type.");
        setLoading(false);
        return;
      }

      if (addedRows.length === 0) {
        ErrorToaster("Please add at least one account.");
        setLoading(false);
        return;
      }
const invalidAccounts = addedRows.some(
  (row) =>
    isNaN(Number(row.amount)) ||
    Number(row.amount) <= 0
);

if (invalidAccounts) {
  ErrorToaster("Amount must be greater than 0 for all accounts.");
  setLoading(false);
  return;
}
      const to2 = (v) => Number((Number(v || 0)).toFixed(2));

      const accountsPayload = addedRows.map((d) => {
        const billAmount = to2(d?.amount);
        const vatAmount = to2(d?.vat_amount);
        const totalAmount = to2(d?.total || billAmount + vatAmount);
        const billAmountLcy = to2(d?.bill_amount_lcy || billAmount);
        const vatAmountLcy = to2(d?.vat_amount_lcy || vatAmount);

        return {
          account_id: d?.account_id,
          full_path: d?.full_path || "",
          bill_amount: billAmount,
          description: d?.description || "",
          vat_amount: vatAmount,
          total_amount: totalAmount,
          vat_code:
            typeof d?.vat_code === "string"
              ? d?.vat_code
              : d?.vat_code?.name || "",
          bill_amount_lcy: billAmountLcy,
          vat_amount_lcy: vatAmountLcy,
        };
      });

      const payloadAedTotal = to2(
        accountsPayload.reduce((sum, row) => sum + Number(row.total_amount || 0), 0),
      );
      const payloadVatAed = to2(
        accountsPayload.reduce((sum, row) => sum + Number(row.vat_amount || 0), 0),
      );
      const payloadUsdTotal = to2(payloadAedTotal / effectiveUsdExchangeRate);
      const payloadVatUsd = to2(payloadVatAed / effectiveUsdExchangeRate);

      const payload = {
        bill_id: parseInt(id),
        supplier_id: parseInt(selectedSupplier?.id),
        bill_reference_no: getValues("refNo"),
        bill_date: billDate,
        bill_no: getValues("billNo"),
        bill_category: selectedBillCategory?.name,
        bill_type: selectedBillType?.name,
        bill_documents: documentList.map((d) => ({
          doc_id: parseInt(d.doc_id),
          invoice_attachment: d.documentLink2,
        })),
        accounts: accountsPayload,
        aed_total: payloadAedTotal,
        usd_total: payloadUsdTotal,
        vat_amount_usd: payloadVatUsd,
        remarks: getValues("remarks") || null,
        vat_amount_aed: payloadVatAed,
        vat_name_5: vatCode5Percent
          ? vatCode5Percent === "GUC SRP5%"
            ? "GUC Input VAT"
            : vatCode5Percent === "GWS SRP5%"
              ? "GWS Input VAT"
              : vatCode5Percent === "ICLGG SRP5%"
                ? "ICL Global Gen. Tr. - Input VAT"
                : vatCode5Percent === "ICLGC SRP5%"
                  ? "ICL Global Cargo. Tr. - Input VAT"
                  : "RAK/sister Co's VAT - P/A or R/A"
          : "RAK/sister Co's VAT - P/A or R/A",
      };

      console.log("Edit Bill Payload:", JSON.stringify(payload, null, 2));

      const response = await SupplierServices.editBill(payload);

      if (response?.responseCode === 200) {
        SuccessToaster("Bill updated successfully.");
        navigate("/bills-&-approvals");
      } else {
        ErrorToaster(response?.message || "Failed to edit bill.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      ErrorToaster(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to edit bill.",
      );
    } finally {
      setLoading(false);
    }
  };
  const getBillDataDetails = async () => {
    try {
      let params = {
        bill_id: id,
      };

      const data = await SupplierServices.getBillDetails(params);
      setBillDetails(data?.data?.bill);
      const billData = data?.data?.bill;

      if (billData) {
        setValue("refNo", billData.bill_reference_no);
        setValue("billNo", billData.bill_no);
        setValue("supplier", billData.supplier_id);
        setValue("billCategory", billData.bill_category);
        setValue("billType", billData.bill_type);
        setValue("remarks", billData.remarks || "");
        setBillDate(new Date(billData.bill_date));

        setSelectedSupplier({
          id: billData.supplier_id,
            name: billData.suppliers?.company_name,
        });

        setSelectedBillCategory({
          id: billData?.bill_category === "Internal" ? 1 : 2,
          name: billData?.bill_category,
        });

        setSelectedBillType({
          id:
            billData?.bill_type === "Planned"
              ? 1
              : billData?.bill_type === "High Value"
                ? 2
                : 3,
          name: billData?.bill_type,
        });

        const documents = billData.bill_documents.map((doc) => ({
          docType: doc?.doc_id === 2 ? "Doc 2" : "Doc 1",
          documentLink2: doc?.invoice_attachment,
          doc_id: doc?.doc_id,
        }));

        setDocumentList(documents);

        const getVatCodeObject = (vatCodeString) => {
          const vatOptions = [
            { id: 1, name: "GUC SRP5%" },
            { id: 2, name: "GWS SRP5%" },
            { id: 3, name: "ICLGG SRP5%" },
            { id: 4, name: "ICLGC SRP5%" },
            { id: 5, name: "RAK SRP5%" },
            { id: 6, name: "ZR 0%" },
            { id: 7, name: "ES" },
            { id: 8, name: "OOS" },
          ];

          return (
            vatOptions.find((option) => option.name === vatCodeString) || {
              id: null,
              name: vatCodeString,
            }
          );
        };
const rowsWithAccountIds = await Promise.all(
  billData.bill_accounts.map(async (account) => {
    let accountId = null;

    try {
      const searchParams = {
        page: 1,
        limit: 1,
        search: account.full_path,
        excludeL2: true,
      };

      const { data: searchData } =
        await FinanceServices.getAllAccountsData(searchParams);

      const matchedAccount = searchData?.accounts?.find((acc) => {
        const accPath = [
          acc?.cat?.name,
          acc?.sub_cat?.name,
          acc?.primary?.name,
          acc?.name,
        ]
          .filter(Boolean)
          .join(" → ");

        return accPath === account.full_path;
      });

      if (matchedAccount) {
        accountId = matchedAccount.id;
      }
      
  
      if (!accountId && account.account_id) {
        accountId = account.account_id;
      }

    } catch (error) {
      console.error("Error fetching account_id for:", account.full_path, error);
 
      accountId = account.account_id || null;
    }

    return {
      row_key: uuidv4(),
      id: account.id,
      bill_account_id: account.id,
      account_id: accountId, 
      full_path: account.full_path || "",
      account_code: account.account_code || "",
      description: account.description || "",
      amount: parseFloat(account.bill_amount) || 0,
      vat_amount: parseFloat(account.vat_amount) || 0,
      vat_code: getVatCodeObject(account.vat_code),
      total: parseFloat(account.total_amount) || 0,
      bill_amount_lcy:
        parseFloat(account.bill_amount_lcy ?? account.bill_amount) || 0,
      vat_amount_lcy:
        parseFloat(account.vat_amount_lcy ?? account.vat_amount) || 0,
    };
  }),
);

        setAddedRows(rowsWithAccountIds);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getSupplierData();
    getBillDataDetails();
  }, []);

  return (
    <Box sx={{ m: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography
          sx={{
            color: "#2C6B2F",
            ml: 1,
            fontSize: "32px",
          }}
        >
          Edit Book Bill
        </Typography>
      </Box>

      <Box sx={{ m: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Supplier"}
              options={suppliers}
              selected={selectedSupplier}
              onSelect={(value) => {
                setSelectedSupplier(value);
              }}
              register={register("supplier", {
                required: "Please select supplier.",
              })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputField
              disabled={false}
              size={"small"}
              label={"Reference no"}
              placeholder={"Enter Reference no"}
              register={register("refNo", {
                required: "Reference no is required.",
              })}
              error={errors?.refNo?.message}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <DatePicker
              label={"Bill Date*"}
              size="small"
              value={billDate}
              onChange={handleBillDate}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <InputField
              disabled={false}
              size={"small"}
              label={"Bill no"}
              placeholder={"Enter Bill no "}
              register={register("billNo", {
                required: "Company is required.",
              })}
              error={errors?.companyName?.message}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label="Bill Category*"
              options={[
                {
                  id: 1,
                  name: "Internal",
                },
                {
                  id: 2,
                  name: "External",
                },
              ]}
              selected={selectedBillCategory}
              onSelect={(value) => {
                setSelectedBillCategory(value);
              }}
              register={register("billCategory", {
                // required: "Please select invoice.",
              })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label="Bill Type"
              options={[
                {
                  id: 1,
                  name: "Planned",
                },
                {
                  id: 2,
                  name: "High Value",
                },
                {
                  id: 3,
                  name: "Ad hoc",
                },
              ]}
              selected={selectedBillType}
              onSelect={(value) => {
                setSelectedBillType(value);
              }}
              register={register("billType", {
                // required: "Please select invoice.",
              })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputField
              disabled={false}
              size={"small"}
              label={"Remarks"}
              placeholder={"Enter Remarks"}
              register={register("remarks")}
              error={errors?.remarks?.message}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <InputField
              size={"small"}
              inputStyle={{ backgroundColor: "#f5f5f5" }}
              label={"Search COA"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register("search", {
                onChange: (e) => handleFilter({ search: e.target.value }),
              })}
            />
          </Grid>

          {searchData?.length > 0 && (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 0.5,
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                  {searchData.map((item, index) => {
                    const open = !!rowOpen[item.id];
                    const pathForItem = path[index];
                    const isChecked = selectedItems[item.id] || false;
                    return (
                      <Box
                        key={item.id}
                        sx={{
                          display: "grid",
                          alignItems: "center",
                          gridTemplateColumns: {
                            xs: isChecked
                              ? "100px 1fr 0.5fr 0.9fr 0.5fr"
                              : "auto 1fr",
                            sm: isChecked
                              ? "100px 1.3fr 0.7fr 1fr 0.5fr"
                              : "auto 1fr",
                            md: isChecked
                              ? "100px 1.4fr 0.7fr 1fr 0.5fr"
                              : "auto 1fr",
                          },

                          columnGap: { xs: 1, sm: 1, md: 1 },
                          px: { xs: 0.5, sm: 1 },
                          py: 1,
                          borderBottom: "1px solid #F1F5F9",
                          "&:last-child": { borderBottom: 0 },
                        }}
                      >
                        <FormControlLabel
                          sx={{ m: 0 }}
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={() => toggleCheckbox(item.id)}
                              // checked={open}
                              // onChange={() => toggleRow(item.id)}
                              sx={{ p: 0.5 }}
                            />
                          }
                          label=""
                        />

                        <Tooltip title={pathForItem} arrow>
                          <Typography
                            sx={{
                              minWidth: 0,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontSize: "12px",
                            }}
                          >
                            {pathForItem}
                          </Typography>
                        </Tooltip>

                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          {isChecked && (
                            <IconButton
                              size="small"
                              onClick={() => handleAddFromSearch(item)}
                              sx={{
                                bgcolor: Colors.primary,
                                color: Colors.white,
                                "&:hover": {
                                  bgcolor: Colors.primary,
                                  color: Colors.white,
                                },
                              }}
                            >
                              <Add />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Grid>
            </>
          )}
  {addedRows.length > 0 && (
            <>
              <Grid item xs={12}>
                <TableContainer component={Paper} sx={{ mt: 2, border: "1px solid #E5E7EB", borderRadius: 2 }}>
                  <Table sx={{ minWidth: 900 }}>
                    <TableHead>
                      <TableRow >
                        <Cell sx={{ minWidth: 60, maxWidth: 500 , textAlign: "left" }}>Full Path</Cell>
                        <Cell sx={{ minWidth: 90 }}>Amount (AED)</Cell>
                        <Cell sx={{ minWidth: 250 }}>Description</Cell>
                        <Cell sx={{ minWidth: 250 }}>VAT Code</Cell>
                        <Cell sx={{ minWidth: 60 }}>VAT Amount (AED)</Cell>
                        <Cell sx={{ minWidth: 60 }}>Total (AED)</Cell>
                        <Cell sx={{ minWidth: 50 }}>Action</Cell>
                      </TableRow>
                    </TableHead>
                    <TableBody>

                      {addedRows.map((r) => (
                        <TableRow key={r.row_key} sx={{ "&:last-child td": { border: 0 } }}>
                          <TableCell sx={{ minWidth: 60, maxWidth: 500 }}>
                             <Tooltip title={r.full_path} arrow>
                            <Typography
                              sx={{
                                minWidth: 0,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              
                              }}
                            >
                              {r.full_path}
                            </Typography>
                          </Tooltip>
                          </TableCell>
                          <TableCell sx={{ minWidth: 90 }}>  <Typography
                            sx={{ textAlign: "center", fontSize: "14px" }}
                          >
                            <InputField
                              size="small"
                              placeholder="0.00"
                              value={r.amount ?? ""}
                              fullWidth
                              register={register(`searchRows.${r.row_key}.amount`, {
                                pattern: /^[0-9]*(\.[0-9]{0,2})?$/,
                                onChange: (e) => {
                                  let v = e.target.value;

                                  v = v.replace(/,/g, "");

                                  if (v !== "" && Number(v) <= 0) {
                                    ErrorToaster("Amount must be greater than 0.");
                                    return;
                                  }

                                  if (
                                    v === "" ||
                                    /^[0-9]*(\.[0-9]{0,2})?$/.test(v)
                                  ) {
                                    updateAddedRow(r.row_key, { amount: v });
                                  }
                                },
                              })}
                            />
                          </Typography></TableCell>
                          <TableCell sx={{ minWidth: 250 }}>
                            <Tooltip title={r.description} arrow>
                              <Typography
                                sx={{
                                  minWidth: 0,
                                  whiteSpace: "normal",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: "14px",
                                }}
                              >
                                <InputField
                                  size="small"
                                  placeholder="Description"
                                  fullWidth
                                  multiline
                                  value={r.description ?? ""}
                                  onChange={(e) => {
                                    updateAddedRow(r.row_key, {
                                      description: e.target.value,
                                    });
                                  }}
                                  onBlur={(e) => {
                                    const cleaned = sanitizeDescription(
                                      e.target.value,
                                    );
                                    updateAddedRow(r.row_key, {
                                      description: cleaned,
                                    });
                                  }}
                                />
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell sx={{ minWidth: 250 }}>  <Typography
                            sx={{ textAlign: "center", fontSize: "14px" }}
                          >
                            <SelectField

                              options={[
                                { id: 1, name: "GUC SRP5%" },
                                { id: 2, name: "GWS SRP5%" },
                                { id: 3, name: "ICLGG SRP5%" },
                                { id: 4, name: "ICLGC SRP5%" },
                                { id: 5, name: "RAK SRP5%" },
                                { id: 6, name: "ZR 0%" },
                                { id: 7, name: "ES" },
                                { id: 8, name: "OOS" },
                              ]}
                              getOptionDisabled={(option) => {
                                // Disable other 5% codes when one is globally applied,
                                // but always keep the globally-applied 5% code itself enabled
                                return isGlobal5Applied && VAT_GLOBAL_5.has(option.name) && option.name !== vatCode5Percent;
                              }}
                              selected={r.vat_code}
                              onSelect={(value) => {
                                const selectedName = value?.name || "";
                                if (VAT_GLOBAL_5.has(selectedName)) {
                                  setAddedRows((prev) =>
                                    prev.map((row) => {
                                      // Always apply to the row the user interacted with
                                      if (row.row_key === r.row_key) return calcRow({ ...row, vat_code: value });
                                      const currentName = getVatName(row.vat_code);
                                      // keep other locked rows untouched
                                      if (VAT_LOCKED.has(currentName)) return row;
                                      return calcRow({ ...row, vat_code: value });
                                    }),
                                  );
                                  return;
                                }
                                if (VAT_LOCKED.has(selectedName)) {
                                  setAddedRows((prev) =>
                                    prev.map((row) =>
                                      row.row_key === r.row_key
                                        ? calcRow({ ...row, vat_code: value })
                                        : row
                                    )
                                  );
                                  return;
                                }
                                setAddedRows((prev) =>
                                  prev.map((row) =>
                                    row.row_key === r.row_key
                                      ? calcRow({ ...row, vat_code: value })
                                      : row
                                  )
                                );
                              }}
                              register={register(`searchRows.${r.row_key}.vatCode`)}
                            />

                            {/* <SelectField
                                                    // label="Attachment Type"
                                                    options={[
                                                        {
                                                            id: 1,
                                                            name: "GUC SRP5%",
                                                        },
                                                        {
                                                            id: 2,
                                                            name: "GWS SRP5%",
                                                        },
                                                        {
                                                            id: 3,
                                                            name: "ICLGG SRP5%",
                                                        },{
                                                            id: 4,
                                                            name: "ICLGC SRP5%",
                                                        },
                                                        {
                                                            id: 5,
                                                            name: "RAK SRP5%",
                                                        },
                                                        {
                                                            id: 6,
                                                            name: "ZR 0%",
                                                        },
                                                        {
                                                            id: 7,
                                                            name: "ES",
                                                        },
                                                        {
                                                            id: 8,
                                                            name: "OOS",
                                                        },
                                                    ]}

                                                    selected={r.vat_code} // Use the row's specific vat_code
                                                    onSelect={(value) => {
                                                        updateAddedRow(r.row_key, { vat_code: value });
                                                    }}
                                                   
                                                    register={register(`searchRows.${r.id}.vatCode`, {
                                                        // required: "Please select invoice.",
                                                    })}
                                                />
                                               */}
                          </Typography>
                          </TableCell>
                          <TableCell sx={{ minWidth: 80 }}>   <Typography
                            sx={{ textAlign: "center", fontSize: "14px" }}
                          >
                            <InputField
                              size="small"
                              disabled={true}
                              placeholder="0.00"
                              value={r.vat_amount ?? ""}
                              fullWidth
                              register={register(`searchRows.${r.row_key}.vat_amount`, {
                                pattern: /^[0-9]*(\.[0-9]{0,2})?$/,
                                onChange: (e) => {
                                  let v = e.target.value;

                                  v = v.replace(/,/g, "");

                                  if (v !== "" && Number(v) <= 0) {
                                    ErrorToaster("Amount must be greater than 0.");
                                    return;
                                  }

                                  if (
                                    v === "" ||
                                    /^[0-9]*(\.[0-9]{0,2})?$/.test(v)
                                  ) {
                                    updateAddedRow(r.row_key, { vat_amount: v });
                                  }
                                },
                              })}
                            />
                          </Typography></TableCell>

                          <TableCell sx={{ minWidth: 70 }}>
                            <Typography>{r?.total}</Typography>
                          </TableCell>

                          <TableCell sx={{ minWidth: 60 }}> <Box >
                            <IconButton
                              size="small"
                              onClick={() => removeAddedRow(r.row_key)}
                            >
                              <Delete
                                sx={{
                                  color: Colors.danger,
                                  height: "20px !important",
                                }}
                              />
                            </IconButton>
                          </Box></TableCell>  </TableRow>

                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "70% 18% 12%",
                    gap: 2,
                    px: 1.5,
                    py: 1,
                    borderBottom: "1px solid #EEF2F7",
                    fontWeight: 700,
                    fontSize: 12,
                  }}
                >
                  <Typography fontWeight={700}>Total</Typography>

                  <Typography fontWeight={700}>
                    $ {CommaSeparator(totals.usd.toFixed(2))}
                  </Typography>
                  <Typography fontWeight={700}>
                    AED {CommaSeparator(totals.aed.toFixed(2))}
                  </Typography>
                </Box>
              </Grid>
            </>
          )}
          {/* {addedRows.length > 0 && (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                 
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "38% 7% 19% 14% 5% 5% 12%",
                      gap: 2,
                      px: 1.5,
                      py: 1,
                      bgcolor: Colors.primary,
                      color: "#ffff",
                      borderBottom: "1px solid #EEF2F7",
                      fontWeight: 700,
                      fontSize: 12,
                    }}
                  >
                    <Typography>Full Path</Typography>
                   
                    <Typography>Amount (AED)</Typography>
                    <Typography>Description</Typography>
                    <Typography>VAT Code</Typography>
                    <Typography>VAT Amount (AED)</Typography>
                    <Typography>Total (AED)</Typography>
                    <Typography>Action</Typography>
                    <Typography />
                  </Box>

                  {addedRows.map((r) => (
                    <Box
                      key={r.row_key}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "38% 7% 19% 14% 5% 5% 12%",
                        // gridTemplateColumns: "60% 15% 25%",
                        gap: 2,
                        px: 1.5,
                        py: 1,
                        borderBottom: "1px solid #F1F5F9",
                        "&:last-child": { borderBottom: 0 },
                      }}
                    >
                      <Tooltip title={r.full_path} arrow>
                        <Typography
                          sx={{
                            minWidth: 0,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            mt: 2,
                          }}
                        >
                          {r.full_path}
                        </Typography>
                      </Tooltip>
                   

                      <Typography
                        sx={{ textAlign: "center", fontSize: "14px" }}
                      >
                        <InputField
                          size="small"
                          placeholder="0.00"
                          value={r.amount ?? ""}
                          fullWidth
                          // onChange={(e) => {
                          //     const v = e.target.value;
                          //     // allow empty or up to 2 decimals
                          //     if (v === "" || /^\d{0,12}(\.\d{0,2})?$/.test(v)) {
                          //         updateAddedRow(r.id, { amount: v === "" ? "" : Number(v) });
                          //     }
                          // }}
                          // InputProps={{
                          //     endAdornment: (
                          //         <InputAdornment position="end">
                          //             AED
                          //         </InputAdornment>
                          //     ),
                          // }}
                          // onChange={(e) => {
                          //   const v = e.target.value;

                          //   // ❌ Block zero or negative
                          //   if (v !== "" && Number(v) <= 0) {
                          //     ErrorToaster("Amount must be greater than 0.");
                          //     return;
                          //   }

                          //   // allow empty or up to 2 decimals
                          //   if (v === "" || /^\d{0,12}(\.\d{0,2})?$/.test(v)) {
                          //     updateAddedRow(r.row_key, {
                          //       amount: v === "" ? "" : Number(v),
                          //     });
                          //   }
                          // }}
                          register={register(`searchRows.${r.row_key}.amount`, {
                            pattern: /^[0-9]*(\.[0-9]{0,2})?$/,
                            onChange: (e) => {
                              let v = e.target.value;

                              v = v.replace(/,/g, "");

                              if (v !== "" && Number(v) <= 0) {
                                ErrorToaster("Amount must be greater than 0.");
                                return;
                              }

                              if (
                                v === "" ||
                                /^[0-9]*(\.[0-9]{0,2})?$/.test(v)
                              ) {
                                updateAddedRow(r.row_key, { amount: v });
                              }
                            },
                          })}
                        />
                      </Typography>

                      <Tooltip title={r.description} arrow>
                        <Typography
                          sx={{
                            minWidth: 0,
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                          }}
                        >
                          <InputField
                            size="small"
                            placeholder="Description"
                            fullWidth
                            multiline
                            value={r.description ?? ""}
                            onChange={(e) => {
                              updateAddedRow(r.row_key, {
                                description: e.target.value,
                              });
                            }}
                            onBlur={(e) => {
                              const cleaned = sanitizeDescription(
                                e.target.value,
                              );
                              updateAddedRow(r.row_key, {
                                description: cleaned,
                              });
                            }}
                            // register={register(`searchRows.${r.id}.description`, {
                            //     validate: validateSafeDescription,
                            //     onBlur: (e) => {
                            //         const cleaned = sanitizeDescription(e.target.value);
                            //         setValue(`searchRows.${r.id}.description`, cleaned, { shouldValidate: true });
                            //     },
                            //     maxLength: {
                            //         value: MAX_DESC_LEN,
                            //         message: `Description must be <= ${MAX_DESC_LEN} characters.`,
                            //     },
                            // })}
                          />
                        </Typography>
                      </Tooltip>

                      <Typography
                        sx={{ textAlign: "center", fontSize: "14px" }}
                      >
                        <SelectField
                          options={[
                            {
                              id: 1,
                              name: "GUC SRP5%",
                            },
                            {
                              id: 2,
                              name: "GWS SRP5%",
                            },
                            {
                              id: 3,
                              name: "ICLGG SRP5%",
                            },
                            {
                              id: 4,
                              name: "ICLGC SRP5%",
                            },
                            {
                              id: 5,
                              name: "RAK SRP5%",
                            },
                            {
                              id: 6,
                              name: "ZR 0%",
                            },
                            {
                              id: 7,
                              name: "ES",
                            },
                            {
                              id: 8,
                              name: "OOS",
                            },
                          ]}
                              getOptionDisabled={(option) => {
                                return isGlobal5Applied && VAT_GLOBAL_5.has(option.name) && option.name !== vatCode5Percent;
                          }}
                          selected={r.vat_code}
                          onSelect={(value) => {
                            updateAddedRow(r.row_key, { vat_code: value });
                          }}

                          register={register(`searchRows.${r.id}.vatCode`, {
                            // required: "Please select invoice.",
                          })}
                        />
                      </Typography>

                      <Typography
                        sx={{ textAlign: "center", fontSize: "14px" }}
                      >
                        <InputField
                          size="small"
                          disabled={true}
                          placeholder="0.00"
                          value={r.vat_amount ?? ""}
                          fullWidth
                          // onChange={(e) => {
                          //     const v = e.target.value;
                          //     // allow empty or up to 2 decimals
                          //     if (v === "" || /^\d{0,12}(\.\d{0,2})?$/.test(v)) {
                          //         updateAddedRow(r.id, { amount: v === "" ? "" : Number(v) });
                          //     }
                          // }}
                          // InputProps={{
                          //     endAdornment: (
                          //         <InputAdornment position="end">
                          //             AED
                          //         </InputAdornment>
                          //     ),
                          // }}
                          register={register(`searchRows.${r.id}.vat_amount`, {
                            pattern: /^[0-9]*(\.[0-9]{0,2})?$/,
                            onChange: (e) => {
                              let v = e.target.value;

                              v = v.replace(/,/g, "");

                              if (v !== "" && Number(v) <= 0) {
                                ErrorToaster("Amount must be greater than 0.");
                                return;
                              }

                              if (
                                v === "" ||
                                /^[0-9]*(\.[0-9]{0,2})?$/.test(v)
                              ) {
                                updateAddedRow(r.row_key, { vat_amount: v });
                              }
                            },
                          })}
                        />
                      </Typography>

                      <Typography sx={{ mt: 2.5 }}>{r?.total}</Typography>

                      <Box sx={{ mt: 2 }}>
                        <IconButton
                          size="small"
                          onClick={() => removeAddedRow(r.row_key)}
                        >
                          <Delete
                            sx={{
                              color: Colors.danger,
                              height: "20px !important",
                            }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Box
                                 sx={{
                                   display: "grid",
                                   gridTemplateColumns: "70% 17% 13%",
                                   gap: 2,
                                   px: 1.5,
                                   py: 1,
                                   borderBottom: "1px solid #EEF2F7",
                                   fontWeight: 700,
                                   fontSize: 12,
                                 }}
                               >
                                 <Typography fontWeight={700}>Total</Typography>
                                 <Typography fontWeight={700}>
                                   AED {CommaSeparator(totals.aed.toFixed(2))}
                                 </Typography>
                                 <Typography fontWeight={700}>
                                   $ {CommaSeparator(totals.usd.toFixed(2))}
                                 </Typography>
               
                               </Box>
              </Grid>
            </>
          )} */}
        </Grid>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <SelectField
              label="Attachment Type"
              options={[
                {
                  id: 1,
                  name: "Doc 1",
                },
                {
                  id: 2,
                  name: "Doc 2",
                },
              ]}
              selected={selectedDocumentType}
              onSelect={(value) => {
                setSelectedDocumentType(value);
              }}
              register={register("periodicInvoice", {
                // required: "Please select invoice.",
              })}
            />
          </Grid>

          <Grid item xs={12} sm={3} mt={3.7}>
            <UploadFile
              custom={true}
              vendor={true}
              acceptedFormats="PDF, JPG"
              style={{
                backgroundColor: "#e7efeb",
                width: "100%",
                height: "40px",
                display: "flex",
                justifyContent: "space-between",
                padding: "20px",
                border: "1px dashed #aeb1b0",
                borderRadius: "10px",
              }}
              register={register("scanned", {
                onChange: (e) => handleUploadDocumentInvoices(e),
              })}
            />
              {documentDetail2?.length > 0 && documentDetail2[0]?.name && (
                          <Box
                            sx={{
                              mt: 1,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              px: 1,
                              py: 0.5,
                              border: "1px solid #d0e8d8",
                              borderRadius: "8px",
                              backgroundColor: "#f0f9f3",
                            }}
                          >
                            <FiFile size={16} color={Colors.primary} style={{ flexShrink: 0 }} />
                            <Tooltip title={documentDetail2[0].name} arrow>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "#333",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "160px",
                                }}
                              >
                                {documentDetail2[0].name}
                              </Typography>
                            </Tooltip>
                            <Typography sx={{ fontSize: "11px", color: "#888", flexShrink: 0 }}>
                              ({documentDetail2[0].size})
                            </Typography>
                          </Box>
                        )}
          </Grid>
          <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
            <IconButton
              size="small"
              onClick={handleAddDocument}
              sx={{
                bgcolor: Colors.primary,
                color: Colors.white,
                "&:hover": {
                  bgcolor: Colors.primary,
                  color: Colors.white,
                },
              }}
            >
              <Add />
            </IconButton>
          </Grid>
          {documentList.length > 0 ? (
            <>
              <Grid item xs={12} sm={12}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="Documents Table">
                    <TableHead
                      sx={{
                        bgcolor: Colors.primary,
                        color: Colors.white,
                      }}
                    >
                      <TableRow>
                        <Cell>Document Type</Cell>
                        <Cell>Attachment</Cell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {documentList.map((doc) => (
                        <TableRow key={doc?.id}>
                          <TableCell>{doc?.docType}</TableCell>
                          <TableCell>
                            {doc?.documentLink2 && doc?.documentLink2 ? (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadAllAttachments(doc?.documentLink2)
                                }
                              >
                                <FiDownload color={Colors.primary} size={25} />
                              </div>
                            ) : (
                              <FiDownload color="gray" size={25} />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          <PrimaryButton
            title={"Upload"}
            loading={loading}
            onClick={handleEditBookBill}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default EditBill;
